module.exports = __webpack_public_path__ + "img/WorkSans-Black.30fa29b.svg";